import {
	CLEAR_LOADROUTES,
	ROUTES_RULES_FAILED,
	ROUTES_RULES_LOADED,
	ROUTES_RULES_LOADING,
	ROUTES_SAVED,
	ROUTES_SAVING,
	ROUTES_SAVING_FAILED,
} from "../actions/types";
const initialState = {
	isLoading: false,
	isLaoded: false,
	isFailed: false,
	routes_rules: null,
	docType: null,
	isSaving: false,
	isSaved: false,
	isSavingFailed: false,
	routes: null,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case ROUTES_RULES_LOADING:
			return {
				...state,
				isLoading: true,
				isLaoded: false,
				isFailed: false,
			};
		case ROUTES_RULES_LOADED:
			return {
				...state,
				isLoading: false,
				isLaoded: true,
				isFailed: false,
				routes_rules: action.payload.routesRules,
				docType: action.payload.docType,
			};
		case ROUTES_RULES_FAILED:
			return {
				...state,
				isLoading: false,
				isLaoded: false,
				isFailed: true,
			};
		case ROUTES_SAVING:
			return {
				...state,
				isSaving: true,
				isSaved: false,
				isSavingFailed: false,
			};
		case ROUTES_SAVED:
			console.log("reducers showing action.payload", action.payload);
			return {
				...state,
				isSaving: false,
				isSaved: true,
				isSavingFailed: false,
				routes: action.payload.routes,
			};
		case ROUTES_SAVING_FAILED:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isSavingFailed: true,
			};
		case CLEAR_LOADROUTES:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isSavingFailed: false,
				routes: null,
			};

		default:
			return state;
	}
}
